import Entity from '../entity';
import Court from './court';

export default class Constitute extends Entity<number>{
    name:string = "";
    startDate: Date = null;
    endDate: Date = null;
    courtIds: string = "";
    days: number = 1;
    payMethod: number = 1;
    bond: number = 0;
    advanceCharge: number = 0;
    shortDesc: string = '';
    description: string = '';
    priceExplain: string = '';
    reserveFlow: string = '';
    reserveNotice: string = '';
    constituteImages: Array<any> = [];
    showOnHome: boolean = false;
    courts: Array<Court> = [];
    displayOrder: number = 0;
    ballNumber:number=0;
    supplierId:number=0;
    remark:string='';
}